import React from 'react';
import './styles.css';

const SubHeading = ({ children }) => {
  return <div className="BusinessesList__SubHeading__root">{children}</div>;
};

export default SubHeading;
